import ConfirmationHeaderPickupStatusContainer from './ConfirmationHeaderPickupStatusContainer';

export default ConfirmationHeaderPickupStatusContainer;
